import _default from '../html';
export { _default as default };
